export default __webpack_public_path__ + "static/media/68t.02b89742.jpg";